import React, { useState } from "react";
import MyProject from "./../../Data/Projects.json";
import Project from "./Project";
import "./Project.css";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";

const Projects = () => {
  const [projects, setProjects] = useState(MyProject.slice(0, 3));
  // console.log(projects);

  return (
    <div className="main py-3 px-3">
      <div className="container pt-5">
        <h2 className="text-center project">Some of my works</h2>
        <hr style={{ color: "white" }} />
        <Fade top>
          <div className="row p-2">
            {projects.map((project) => (
              <Project project={project} key={project.id}></Project>
            ))}
            <span className="text-center span">
              {" "}
              <Link
                to="/Projects"
                style={{ textDecoration: "none", color: "green" }}
              >
                See More{" "}
              </Link>
            </span>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Projects;
